import React from 'react';
import { Form, FormProps } from 'antd';
import { CheckCircleTwoTone, ExclamationCircleTwoTone, LoadingOutlined } from '@ant-design/icons';

const FormCommon: React.FC<FormProps> = ({ children, ...props }) => {
  return (
    <Form
      {...props}
      feedbackIcons={() => ({
        success: <CheckCircleTwoTone twoToneColor='#52c41a' />,
        error: <ExclamationCircleTwoTone twoToneColor='#ff4d4f' />,
        warning: <ExclamationCircleTwoTone twoToneColor='#faad14' />,
        validating: <LoadingOutlined />,
      })}
    >
      {children as React.ReactNode}
    </Form>
  );
};

export default FormCommon;
